import { api } from "./api";

const bankinfoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTransaction: builder.query({
      query: () => "all_jv",
      providesTags: ["all_jv"],
    }),
    getMrTransaction: builder.query({
      query: () => "all_mr",
      providesTags: ["all_jv"],
    }),
    getPyTransaction: builder.query({
      query: () => "all_py",
      providesTags: ["all_jv"],
    }),
    mrReceipt: builder.query({
      query: (mr) => `receipt_by_mr?mr=${mr}`,
      providesTags: ["all_jv"],
    }),
    pyReceipt: builder.query({
      query: (py) => `receipt_by_py?py=${py}`,
      providesTags: ["all_jv"],
    }),
    statementQuery: builder.query({
      query: ({ legId, tagID }) =>
        `TransactionQuery?legId=${legId}&tagID=${tagID}`,
      providesTags: ["all_jv"],
    }),
    pendingTr: builder.query({
      query: () => `pending_tr`,
      providesTags: ["all_jv"],
    }),
    addTransaction: builder.mutation({
      query: (newCategory) => ({
        url: "Transaction",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["all_jv"],
    }),
    addMrTransaction: builder.mutation({
      query: (data) => ({
        url: "mr_entry",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["all_jv"],
    }),
    removeTransaction: builder.mutation({
      query: (id) => ({
        url: `Transactionss?invoice_id=${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["all_jv"],
    }),
    updatePendingStatus: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `update_status/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["all_jv"],
    }),
    editTransaction: builder.mutation({
      query: (editData) => ({
        url: `Transaction`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["all_jv"],
    }),
  }),
});

export const {
  useGetTransactionQuery,
  useGetMrTransactionQuery,
  useGetPyTransactionQuery,
  useMrReceiptQuery,
  usePyReceiptQuery,
  usePendingTrQuery,
  useStatementQueryQuery,
  useAddTransactionMutation,
  useAddMrTransactionMutation,
  useRemoveTransactionMutation,
  useUpdatePendingStatusMutation,
  useEditTransactionMutation,
} = bankinfoApi;
